import { DATE_FORMAT_OPTIONS } from '../constants/config';

// Format date with EST/EDT timezone
export const formatDateEST = (date) => {
  return date.toLocaleString('en-US', DATE_FORMAT_OPTIONS);
};

// Format date for API calls
export const formatDateForAPI = (date) => {
  return date.toISOString().split('T')[0].replace(/-/g, '');
};

// Check if flag data is stale
export const isFlagDataStale = (lastChecked, beachHours) => {
  if (!lastChecked) return true;
  
  const estHour = parseInt(new Date().toLocaleString('en-US', { 
    timeZone: 'America/New_York', 
    hour: 'numeric',
    hour12: false 
  }));
  
  const timeSinceCheck = Date.now() - lastChecked;
  const oneHour = 60 * 60 * 1000;
  const threeHours = 3 * oneHour;
  
  // During beach hours (9am-6pm EST), check every hour
  if (estHour >= beachHours.start && estHour <= beachHours.end) {
    return timeSinceCheck > oneHour;
  }
  
  // Outside beach hours, check every 3 hours
  return timeSinceCheck > threeHours;
};